import { useState, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Router from "next/router";

import { Card, Alert, Spin, Button } from "antd";
import { Turnstile } from "@marsidev/react-turnstile";

import SiteLayout from "~/components/layout/SiteLayout";
import { verifyTurnstile } from "~/redux/actions/turnstile";
import { clearVerificationCookie } from "~/utils/verification";
import settings from "~/settings";

const VerificationPage = (props) => {
  const { redirect } = props;

  const [verificationState, setVerificationState] = useState({
    verifying: false,
    error: null,
    widgetKey: 0, // 用于强制重新渲染 widget
  });
  const [widgetLoaded, setWidgetLoaded] = useState(false);
  const isVerifyingRef = useRef(false); // 防止重复验证

  const handleTurnstileWidgetLoaded = () => {
    setWidgetLoaded(true);
  };

  const handleTurnstileSuccess = async (token) => {
    // 如果正在验证中，忽略新的回调
    if (isVerifyingRef.current) {
      return;
    }

    isVerifyingRef.current = true;
    setVerificationState((prev) => ({
      ...prev,
      verifying: true,
      error: null,
    }));

    try {
      await props.verifyTurnstile({ token });
      // 验证成功，跳转回原页面或首页
      Router.replace(redirect || "/");
    } catch (err) {
      isVerifyingRef.current = false;
      setVerificationState((prev) => ({
        ...prev,
        verifying: false,
        error: err.message || "验证失败，请重试",
        widgetKey: prev.widgetKey + 1, // 重置 widget，防止自动重试
      }));
    }
  };

  const handleTurnstileError = () => {
    // 如果正在验证中，忽略错误回调
    if (isVerifyingRef.current) {
      return;
    }
    setVerificationState((prev) => ({
      ...prev,
      verifying: false,
      error: "验证组件加载失败，请刷新页面重试",
      widgetKey: prev.widgetKey + 1, // 重置 widget，防止自动重试
    }));
  };

  const handleRetry = () => {
    isVerifyingRef.current = false; // 重置验证标志
    setVerificationState({
      verifying: false,
      error: null,
      widgetKey: verificationState.widgetKey + 1, // 重置 widget 以重新验证
    });
  };

  const handleClearAndRetry = () => {
    // 清除失效的 cookie
    clearVerificationCookie();
    // 刷新页面以重新验证
    window.location.reload();
  };

  return (
    <SiteLayout>
      <Card style={{ textAlign: "center", padding: "60px 20px" }}>
        {widgetLoaded && (
          <p
            style={{
              fontSize: "14px",
              marginTop: 10,
              marginBottom: 30,
              color: "#a8a8a8",
            }}
          >
            请等待以下验证完成
          </p>
        )}
        {!verificationState.error && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 20,
            }}
          >
            <Turnstile
              siteKey={settings.turnstileSiteKey}
              options={{
                language: "zh-cn",
                theme: "light",
                retry: "never",
              }}
              onWidgetLoad={handleTurnstileWidgetLoaded}
              onSuccess={handleTurnstileSuccess}
              onError={handleTurnstileError}
              onExpire={handleTurnstileError}
              onTimeout={handleTurnstileError}
            />
          </div>
        )}
        <div style={{ marginTop: 20 }}>
          <Spin tip="验证中..." />
        </div>
        {verificationState.error && (
          <div style={{ marginTop: 16 }}>
            <Alert
              type="error"
              message={verificationState.error}
              style={{ marginBottom: 16 }}
            />
            <Button
              type="primary"
              onClick={handleRetry}
            >
              重新验证
            </Button>
          </div>
        )}
      </Card>
    </SiteLayout>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      verifyTurnstile,
    },
    dispatch
  );

VerificationPage.requireUser = () => false;

VerificationPage.getInitialProps = async (ctx) => {
  const { query } = ctx;
  const { redirect } = query;

  return {
    redirect: redirect ? decodeURIComponent(redirect) : null,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VerificationPage);
